<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 offset-md-3 offset-md-3 mt-5">
                <app-card :title="$t('Verify email')">
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="send(validate)">
                            <div v-if="status" class="alert alert-success" role="alert">
                                {{ status }}
                            </div>

                            <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">
                                <template #label>
                                    {{ $t('Email') }}
                                </template>
                            </app-input>

                            <app-button :loading="loading" small>
                                {{ $t('Send verification link') }}
                            </app-button>
                        </form>
                    </validation-observer>
                </app-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            status: '',
            loading: false,
            form: {
                email: ''
            }
        };
    },
    methods: {
        send(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    axios.post('/email/resend', this.form).then(res => {
                        this.status = res.data.status;
                        this.form.email = '';
                        this.loading = false;
                    });
                }
            });
        }
    },
    created() {
        if (this.$route.query.email) {
            this.form.email = this.$route.query.email;
        }
    }
};
</script>
